import { Row, Tooltip } from 'antd'
import { Icon } from '@iconify/react/dist/iconify.js'
import styles from '../../testrun.module.css'

export function DrawerTitle({ title, onClose }) {
    return (
        <Row
            justify="space-between"
            align="center"
            className={styles.drawerTitleRow}
        >
            <span className={styles.drawerTitle}>{title}</span>
            <Tooltip title="Close" placement="top">
                <Icon
                    icon="ph:arrow-line-right"
                    onClick={onClose}
                    height={20}
                    width={20}
                    className={styles.drawerCloseIcon}
                />
            </Tooltip>
        </Row>
    )
}

export default DrawerTitle
